// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","tabListContainer":"_3qUMW","tabsContainer":"tmOis","tab":"_3DHIS","default":"ip0QK","selected":"_2umGr","with_arrow":"_2quhS"};